import React, { useState } from 'react';

function Contact() {
  const [form, setForm] = useState({ name: '', phone: '', email: '', subject: '', message: '' });

  function handleChange(e) {
    setForm(function(prev) { return { ...prev, [e.target.name]: e.target.value }; });
  }

  function handleSubmit(e) {
    e.preventDefault();
    const body =
      'Name: ' + form.name + '\n' +
      'Phone: ' + form.phone + '\n' +
      'Email: ' + form.email + '\n\n' +
      form.message;
    window.location.href =
      'mailto:info.blackrock@rrc.mn' +
      '?subject=' + encodeURIComponent(form.subject || 'Message from website') +
      '&body=' + encodeURIComponent(body);
  }

  return (
    <>

      {/* <!-- Header Banner --> */}
      <section className="banner-header bg-img bg-fixed" data-overlay-dark="5" style={{ backgroundImage: `url(${process.env.PUBLIC_URL}/img/rooms/01.jpg)` }} >
        <div className="container">
          <div className="row">
            <div className="col-md-12">
              <div className="subtitle">We’re ready to rock your next escape</div>
              <div className="title">Contact</div>
            </div>
          </div>
        </div>
      </section>

      {/* Contact section */}
      <section className="cpage">

        {/* Info cards */}
        <div className="cpage__info">
          <div className="container">
            <div className="cpage__cards">
              <div className="cpage__card">
                <div className="cpage__card-icon"><i className="fa-thin fa-location-dot"></i></div>
                <div className="cpage__card-label">Address</div>
                <div className="cpage__card-value">East Shore of Khuvsgul Lake, 1st Bag, Chandmani-Undur Soum, Khuvsgul Province, Mongolia</div>
              </div>
              <div className="cpage__card-divider" />
              <div className="cpage__card">
                <div className="cpage__card-icon"><i className="fa-thin fa-phone"></i></div>
                <div className="cpage__card-label">Phone</div>
                <div className="cpage__card-value">
                  <a href="tel:+97675100111">+976 75100111</a>
                </div>
              </div>
              <div className="cpage__card-divider" />
              <div className="cpage__card">
                <div className="cpage__card-icon"><i className="fa-thin fa-envelope"></i></div>
                <div className="cpage__card-label">Email</div>
                <div className="cpage__card-value">
                  <a href="mailto:info.blackrock@rrc.mn">info.blackrock@rrc.mn</a>
                </div>
              </div>
            </div>
          </div>
        </div>

        {/* Map + Form */}
        <div className="cpage__body-outer">
          <div className="cpage__body">

            {/* Map */}
            <div className="cpage__map">
              <iframe
                src="https://maps.google.com/maps?q=50.5533548,100.4290239&t=m&z=15&output=embed&iwloc=near"
                width="100%"
                height="100%"
                style={{ border: 0, display: 'block' }}
                allowFullScreen
                loading="lazy"
                title="Google Map"
              />
              <div className="cpage__map-badge">
                <div className="cpage__map-badge-icon"><i className="fa-thin fa-location-dot" /></div>
                <div className="cpage__map-badge-text">
                  <div className="cpage__map-badge-name">Black Rock Luxury Hotel</div>
                  <div className="cpage__map-badge-addr">Khuvsgul Lake · Mongolia</div>
                </div>
                <a
                  href="https://maps.google.com/maps?q=50.5533548,100.4290239"
                  target="_blank"
                  rel="noreferrer"
                  className="cpage__map-badge-link"
                >
                  <i className="fa-thin fa-arrow-up-right-from-square" />
                </a>
              </div>
            </div>

            {/* Form */}
            <div className="cpage__form-wrap">
              <div className="cpage__form-inner">
                <div className="cpage__form-label">Get in Touch</div>
                <h3 className="cpage__form-title">Send us a Message</h3>
                <div className="cpage__form-divider" />
                <form className="cpage__form-grid" onSubmit={handleSubmit}>
                  <div className="cpage__field">
                    <label className="cpage__field-label">Full Name</label>
                    <input type="text" name="name" placeholder="Your full name" required value={form.name} onChange={handleChange} />
                  </div>
                  <div className="cpage__field">
                    <label className="cpage__field-label">Phone</label>
                    <input type="tel" name="phone" placeholder="+976 ..." value={form.phone} onChange={handleChange} />
                  </div>
                  <div className="cpage__field cpage__field--full">
                    <label className="cpage__field-label">Email Address</label>
                    <input type="email" name="email" placeholder="email@example.com" required value={form.email} onChange={handleChange} />
                  </div>
                  <div className="cpage__field cpage__field--full">
                    <label className="cpage__field-label">Subject</label>
                    <input type="text" name="subject" placeholder="How can we help?" value={form.subject} onChange={handleChange} />
                  </div>
                  <div className="cpage__field cpage__field--full">
                    <label className="cpage__field-label">Message</label>
                    <textarea rows="4" name="message" placeholder="Tell us about your request..." value={form.message} onChange={handleChange}></textarea>
                  </div>
                  <div className="cpage__field cpage__field--full">
                    <button type="submit" className="cpage__submit">
                      Send Message &nbsp;<i className="fa-thin fa-paper-plane" />
                    </button>
                  </div>
                </form>
              </div>
            </div>

          </div>
        </div>

      </section>
    </>
  );
}

export default Contact;